






























import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faChartLine,
  faChevronCircleDown,
  faChevronCircleUp,
  faHandshake,
  faBrowser,
  faCog,
  faShoppingBasket,
  faTags,
  faUsers,
  faCreditCard,
  faServer,
  faLanguage,
  faRocket
} from '@fortawesome/pro-light-svg-icons';
import { faConnectdevelop, faAmazon } from '@fortawesome/free-brands-svg-icons';
library.add(
  faChartLine,
  faChevronCircleDown,
  faChevronCircleUp,
  faConnectdevelop,
  faHandshake,
  faBrowser,
  faCog,
  faShoppingBasket,
  faTags,
  faUsers,
  faAmazon,
  faCreditCard,
  faServer,
  faLanguage,
  faRocket
);

import { Component, Prop, Vue } from 'vue-property-decorator';
import SideNavItem from './SideNavItem.vue';
import { Getter } from 'vuex-class';
import { Permissions, NavItem } from '../../../types';

@Component({
  name: 'side-nav',
  components: {
    SideNavItem
  }
})
export default class SideNav extends Vue {
  @Getter
  hasPermission!: (permission: string) => boolean;

  get items(): NavItem[] {
    const items: NavItem[] = [
      {
        route: 'dashboard',
        title: 'Dashboard',
        icon: 'chart-line',
        iconStyle: 'fal',
        show: true
      },
      {
        route: 'services',
        title: 'Services',
        icon: 'server',
        iconStyle: 'fal',
        show: this.hasPermission(Permissions.CREATE_SERVICE_VERSION)
      },
      {
        route: 'merchants',
        title: 'Merchants',
        icon: 'handshake',
        iconStyle: 'fal',
        show: this.hasPermission(Permissions.QUERY_MERCHANTS)
      },
      {
        route: 'networks',
        title: 'Networks',
        icon: 'connectdevelop',
        iconStyle: 'fab',
        show: this.hasPermission(Permissions.QUERY_NETWORKS)
      },
      {
        route: 'translations',
        title: 'Translations',
        icon: 'language',
        iconStyle: 'fal',
        show: this.hasPermission(Permissions.QUERY_TRANSLATIONS)
      },
      {
        route: 'users',
        title: 'Users',
        icon: 'users',
        iconStyle: 'fal',
        show: this.hasPermission(Permissions.QUERY_USERS)
      },
      {
        route: 'settings',
        title: 'Settings',
        icon: 'cog',
        iconStyle: 'fal',
        show: this.hasPermission(Permissions.MUTATE_SETTING)
      }
    ];

    return items.filter(i => i.show);
  }
}
